<template>
    <v-card class="elevation-1 pa-3 login-card">
        <v-card-text>
            <div class="layout column align-center">
                <img src="@/images/LogoLogin.png" alt="Todocolegios" style="width: auto; height: 190px" />
            </div>
            <v-form ref="loginForm" v-model="isValidForm">
                <v-text-field
                    append-outer-icon="person"
                    autofocus
                    label="Usuario"
                    type="text"
                    v-model="model.username"
                    :rules="loginFieldRules"
                    :error-messages="loginFieldErrors"
                    @keydown="loginFieldErrors = []"
                >
                </v-text-field>
                <v-text-field
                    append-outer-icon="lock"
                    :append-icon="showText ? 'visibility' : 'visibility_off'"
                    label="Contraseña"
                    :type="showText ? 'text' : 'password'"
                    @click:append="showText = !showText"
                    v-model="model.password"
                    :rules="passwordFieldRules"
                    :error-messages="passwordFieldErrors"
                    @keydown="passwordFieldErrors = []"
                    @keypress.enter="login"
                >
                </v-text-field>
            </v-form>
        </v-card-text>
        <div class="login-btn">
            <v-btn block color="primary" @click="login" :loading="loading" :disabled="!isValidForm">Auntenticar</v-btn>
        </div>
    </v-card>
</template>

<script>
import Vue from "vue"

export default {
    data: () => ({
        loading: false,
        model: {
            username: "",
            password: ""
        },

        //Campo de contraseña o texto
        showText: false,

        // Formulario
        isValidForm: true,
        loginFieldRules: [v => !!v || "Debe proporcionar un nombre de usuario."],
        loginFieldErrors: [],
        passwordFieldRules: [v => !!v || "Debe proporcionar una contraseña."],
        passwordFieldErrors: []
    }),

    methods: {
        login() {
            if (this.$refs.loginForm.validate()) {
                this.loading = true
                this.$store.dispatch("LOGIN", this.model).then(
                    loginResponse => {
                        this.loading = false
                        if (loginResponse.logginSuccess) {
                            this.$store.dispatch("USER_ROLES").then(response => {
                                if (response) {
                                    this.$router.push({ path: "/dashboard" })
                                    Vue.notify({
                                        group: "auth",
                                        type: "success",
                                        title: "Autenticación",
                                        text: `Usuario ${
                                            this.$store.getters.CURRENT_USER.username
                                        } registrado en el sistema`
                                    })
                                }
                            })
                        }
                        if (!loginResponse.logginSuccess) {
                            this.model.password = ""
                            let { data, status } = loginResponse
                            if (status === 422) {
                                // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                                data.forEach(error => {
                                    switch (error.field) {
                                        case "username":
                                            this.loginFieldErrors.push(error.message)
                                            break
                                        case "password":
                                            this.passwordFieldErrors.push(error.message)
                                            break
                                    }
                                })
                            } else {
                                // Para cualquier otro error, mostrar en mensaje de error
                                Vue.notify({
                                    group: "pages",
                                    type: "error",
                                    title: "Validación",
                                    text: error.message
                                })
                            }
                        }
                    },
                    () => {
                        this.loading = false
                    }
                )
            }
        }
    },
    computed: {}
}
</script>
<style scoped lang="css"></style>
